import { ClerkProvider } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import { ReactNode } from 'react';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Clerk Publishable Key');
}

export default function ClerkWrapper({ children }: { children: ReactNode }) {
  const navigate = useNavigate();

  return (
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      routing="path"
      path="/"
      navigate={(to) => navigate(to)}
      afterSignOutUrl="/"
      signInUrl="/login"
      signUpUrl="/signup"
      signInFallbackRedirectUrl="/shop"
      signUpFallbackRedirectUrl="/shop"
      appearance={{
        elements: {
          formButtonPrimary: 'bg-red-600 hover:bg-red-700',
          socialButtonsBlockButton: 'border-2 hover:bg-gray-50',
        }
      }}
    >
      {children}
    </ClerkProvider>
  );
}